import Vue from 'vue';

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ko.js';
import 'element-ui/lib/theme-chalk/index.css';

import { ElementTiptapPlugin } from 'element-tiptap';
import 'element-tiptap/lib/index.css';

import VueDaumPostcode from 'vue-daum-postcode';

import * as filters from '@/utils/filters';

import App from './App.vue';
import router from './router';
import store from './store';

import Component from 'vue-class-component';

import '@/permission';

import 'moment/locale/ko';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);

Vue.use(ElementUI, { locale });
Vue.use(VueDaumPostcode);
Vue.use(ElementTiptapPlugin, { lang: 'ko', spellCheck: true });

Vue.config.productionTip = false;

Object.keys(filters).forEach((key) => {
  Vue.filter(key, (filters as { [key: string]: Function })[key]);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
